import { useRef } from 'react';
import AiSearchInput from './AiSearchInput';
import AiSearchToolbar from './AiSearchToolbar';
import AiSearchRecentPanel from './AiSearchRecentPanel';
import { useAiSearchContext } from '../AiSearchContext';
import Icon from '@/components/atoms/Icon';
import { classnames } from '@/libs/utils';

interface AiSearchFormProps {
  className?: string;
}

function AiSearchForm({ className = '' }: AiSearchFormProps) {
  const formRef = useRef<HTMLFormElement>(null);

  const {
    prompt,
    isLoading,
    arePromptOptionsVisible,
    isRecentSearchesVisible,
    setPrompt,
    showPromptOptions,
    closePromptOptions,
    closeRecentSearches,
    handleRelevantSourceGeneration,
    inputRef
  } = useAiSearchContext();

  return (
    <div className={classnames('mx-auto w-full max-w-3xl', className)} data-testid="ai-search-form-wrapper">
      <div className="mb-4 text-center text-xl font-medium text-slate-800">Find clips across your video library</div>
      <form
        ref={formRef}
        className="relative flex flex-col items-center justify-center rounded-[14px] border border-slate-200 bg-slate-50 p-2 shadow-sm"
        onSubmit={handleRelevantSourceGeneration}
        data-testid="ai-search-form"
      >
        {/* Click outside overlay for recent searches */}
        {isRecentSearchesVisible && (
          <div className="fixed inset-0 z-40" onClick={closeRecentSearches} data-testid="recent-searches-overlay" />
        )}

        {/* Click outside overlay for prompt options */}
        {arePromptOptionsVisible && (
          <div className="fixed inset-0 z-[70]" onClick={closePromptOptions} data-testid="prompt-options-overlay" />
        )}

        {/* Main Search Input Area */}
        <div className="mb-2 flex w-full items-start justify-center gap-2">
          <div className="mr-1 flex items-center py-2">
            <Icon name="IconSearch" size={18} className="text-orange-500" />
            <Icon name="IconSparkles" size={8} className="absolute left-5 top-3 text-orange-500" />
          </div>

          <AiSearchInput
            ref={inputRef}
            value={prompt}
            onChange={setPrompt}
            onFocus={showPromptOptions}
            disabled={isLoading}
            placeholder="Describe what you're looking for eg: 'Highlights from latest events talking about thought leadership'"
          />
        </div>

        {/* Toolbar */}
        <AiSearchToolbar />

        {/* Recent Searches Panel */}
        <AiSearchRecentPanel />
      </form>
    </div>
  );
}

export default AiSearchForm;
